import { Compass } from 'lucide-react';
import type { ConfidenceId } from '../../types/ids';
import type { ChannelRoleResult } from '../../types/result';
import { SectionHeading } from './SectionHeading';

const CONFIDENCE_LABEL: Record<ConfidenceId, string> = {
  low: 'niedrig',
  medium: 'mittel',
  high: 'hoch',
};

interface ChannelRoleSectionProps {
  channelRole: ChannelRoleResult;
}

/** Empfohlene Rolle von Instagram (Abschnitt 19.4). */
export function ChannelRoleSection({ channelRole }: ChannelRoleSectionProps) {
  return (
    <section className="card stack">
      <SectionHeading icon={Compass}>Empfohlene Rolle von Instagram</SectionHeading>
      <p className="pill">{channelRole.label}</p>
      <p>{channelRole.summary}</p>
      <p>{channelRole.explanation}</p>

      <div>
        <p>
          <strong>Geeignet für</strong>
        </p>
        <ul>
          {channelRole.suitableUses.map((use) => (
            <li key={use}>{use}</li>
          ))}
        </ul>
      </div>

      <div>
        <p>
          <strong>Nicht geeignet für</strong>
        </p>
        <ul>
          {channelRole.unsuitableUses.map((use) => (
            <li key={use}>{use}</li>
          ))}
        </ul>
      </div>

      <p>Sicherheit dieser Empfehlung: {CONFIDENCE_LABEL[channelRole.confidence]}</p>
    </section>
  );
}
